<template>
    <b-form-select v-model="selectedItem" id="mailAccount" :plain="true" :options="this.optionsDDL" @change="onChange"></b-form-select>
</template>

<script>

import axios from "axios";

export default {
  name: "DdlMailAccountComponent",
  props: {
    companyId: Number,
    currentMailAccountId: String
  },
  data() {
    return {
        optionsDDL: [],
        selectedItem: this.currentMailAccountId
    }
  },
  watch: {
    companyId: {
      immediate: true,
      handler(newValue) {
        this.getMailAccount(newValue);
      },
    },
    currentMailAccountId: {
      immediate: true,
      handler(newValue) {
        this.selectedItem = newValue;
      },
    },
  },
  methods: {
    async getMailAccount(companyId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        if(!companyId) {
          companyId = currentUser.companyId
        }
        
        await axios.get(
              this.$store.state.ws_url + "/sys/mail/account/ddl?companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.optionsDDL = resp.data.obj;
          })
          .catch(function(error) {
              console.log(error);
          });
        
    },
    onChange() {
      this.$emit('item-selected', this.selectedItem);
    }
   
  }
  
};

</script>
